import * as angular from "angular";
import "./tacho.html";
import "./tacho.scss";

import { IDriverTachoHours } from "@services/tacho.service";
import { SessionService } from "@services/session.service";
import { SettingsName } from "src/app/class/SettingsName";
import { ICombinedPreferences } from "@interfaces/ICombinedPreferences";

export interface IAggregateDriverTachoInfo {
    driversInOkState: number;
    driversInWarningState: number;
    driversInErrorState: number;

    averageDailyDrive: number;
    averageWeeklyDrive: number;
    averageTwoWeeklyDrive: number;

    driverWithMaxDailyHours?: IDriverTachoHours;
    driverWithMinDailyHours?: IDriverTachoHours;
}

export class TachoController {

    loading = false;

    showHoursOfService = false;

    userOptions: ICombinedPreferences;

    static $inject = ["sessionService"];

    constructor(
        private readonly sessionService: SessionService
    ) {

        this.userOptions = this.sessionService.getItem<ICombinedPreferences>(SettingsName.UserOptions);
        
        this.showHoursOfService = this.userOptions.CountryCode.Value == "CA" || this.userOptions.CountryCode.Value == "US";       
    }

    // ---------------------------------------------

}
